/**
 * <s-seat-request> wraps the free five-seat request form on the homepage.
 * On submit it folds the Builder, City, State, ZIP, and Phone answers into the customer
 * tags field, so each request is saved on the customer record and can start
 * the follow-up email automation. Commas are stripped because tags are
 * comma-separated.
 */
class SeatRequest extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
  }

  handleSubmit() {
    const tagsInput = this.form.querySelector('[data-seat-request-tags]');
    if (!tagsInput) return;
    const baseTag = tagsInput.dataset.baseTag || '';
    const clean = (value) => (value || '').replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
    const tags = [baseTag];
    this.form.querySelectorAll('[data-seat-request-tag]').forEach((field) => {
      const value = clean(field.value);
      if (value) tags.push(`${field.dataset.seatRequestTag}: ${value}`);
    });
    tagsInput.value = tags.filter(Boolean).join(', ');
  }
}

if (!customElements.get('s-seat-request')) {
  customElements.define('s-seat-request', SeatRequest);
}
